$(document).ready(function () {
    addToLikes();
});

function addToLikes() {
    var heart = $('a.add-to-liked');

    if (heart.length > 0) {
        heart.on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('added')) {
                console.log('testas');
                // todo: paleidžiama remove from likes php funkcija
            } else {
                $.ajax({
                    url: awsm.ajax_url,
                    data: {
                        'action': 'addtoliked',
                        'productID': $(this).data('product-id')
                    },
                    success: function() {
                        $(this).addClass('added');
                    }
                });

                // todo: paleidžiama add to likes php funkcija
            }
        });
    }
}